export default __webpack_public_path__ + "static/media/005-dumper truck.c1763ca1.svg";